import React from 'react';
import { Package } from 'lucide-react';

const SoftwarePlaceholder = () => {
    return (
        <>
            <div className="text-center p-8 rounded-xl bg-slate-100 border border-dashed border-slate-300 mt-8">
                <div className="inline-block bg-white p-4 rounded-full mb-4 shadow-sm">
                    <Package size={32} className="text-slate-400" />
                </div>
                <h3 className="text-lg font-bold text-slate-700">Nuevas herramientas en desarrollo</h3>
                <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">
                    Los scripts, add-ons y plantillas de reportes que estamos preparando para que puedas potenciar tu sistema con total libertad, aparecerán aquí.
                </p>
            </div>
        </>
    );
};

export default SoftwarePlaceholder;
